export function init() {
}
export function shutdown() {
}
export function load(filepath, flags) {
    return 0;
}
export function loadMemory(data, flags) {
    return 0;
}
export function unload(name) {
}
export function voice(buffer, gain, pan, rate, flags, bus) {
    return 0;
}
export function stop(name) {
}
export function set(name, param, value) {
}
export function get(name, param) {
    return 0;
}
export function vibrate(duration) {
    return 1;
}
//# sourceMappingURL=index.js.map